// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import siteMessage from "@insite/client-framework/SiteMessage";
import { isOutOfStock } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import React from "react";

export const getCartLineErrorMessages = (cartLines: CartLineModel[], currentCartLine: CartLineModel) => {
    const errorMessages: React.ReactNode[] = [];
    const sumQtyPerUom = cartLines!.reduce((sum, current) => {
        return current.productId === currentCartLine.productId
            ? sum + current.qtyPerBaseUnitOfMeasure * current.qtyOrdered!
            : sum;
    }, 0);

    if (currentCartLine.hasInsufficientInventory && !isOutOfStock(currentCartLine)) {
        const tooManyRequestedMessage = siteMessage(
            "Cart_ToManyQtyRequested",
            currentCartLine.qtyOnHand.toLocaleString(),
            sumQtyPerUom.toLocaleString(),
        );
        errorMessages.push(tooManyRequestedMessage);
    }

    if (!currentCartLine.isActive) {
        errorMessages.push(translate("Inactive Product"));
    }

    if (currentCartLine.cantBuy) {
        errorMessages.push(translate("View-only product"));
    }

    return errorMessages.length > 0 ? errorMessages : undefined;
};
